import { FormEvent } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";
import { MessagingTemplateVariablesValidationErrors } from "@idw-types/common/validation/messaging-template/messaging-template-validation-errors";
import { ThemingConfigurationContainer } from "@containers/common/theming-configuration-container/theming-configuration-container";
import { ThemingFormContainer } from "@containers/common/theming-form-container/theming-form-container";
import { MessagingTemplateVariablesFormSection } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-variables-tab/messaging-template-variables-form-section/messaging-template-variables-form-section";
import { MessagingTemplatePreviewContainer } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-preview-container/messaging-template-preview-container";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";

type MessagingTemplateVariablesFormProps = {
    state: FormattedMessagingTemplate;
    requestInProgress: boolean;
    selectedLanguage: LocaleTypes;
    validationErrors: MessagingTemplateVariablesValidationErrors;
    setSelectedLanguage: (language: LocaleTypes) => void;
    setState: (state: FormattedMessagingTemplate) => void;
    onBackClicked: () => void;
    handleSubmit: (event: FormEvent) => void;
};

export const MessagingTemplateVariablesForm = (props: MessagingTemplateVariablesFormProps) => {
    const {
        state,
        requestInProgress,
        selectedLanguage,
        validationErrors,
        setSelectedLanguage,
        setState,
        onBackClicked,
        handleSubmit
    } = props;



    const resource = resources.modals.addMessagingTemplate;

    return (
        <Form onSubmit={handleSubmit}>
            <Modal.Header id={"add-messaging-template-title"} closeButton>
                <Modal.Title>{resource.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ThemingConfigurationContainer>
                    <ThemingFormContainer>
                        <MessagingTemplateVariablesFormSection
                            isDisabled={false}
                            labelWidth={LabelWidthTypes.MEDIUM}
                            selectedLanguage={selectedLanguage}
                            setMessagingTemplateState={setState}
                            setSelectedLanguage={setSelectedLanguage}
                            state={state}
                            validationErrors={validationErrors}
                        />
                    </ThemingFormContainer>
                    <MessagingTemplatePreviewContainer
                        state={state}
                        selectedLanguage={selectedLanguage}
                    />
                </ThemingConfigurationContainer>
            </Modal.Body>
            <Modal.Footer>
                <Button id="add-messaging-template-back-button" variant="secondary" onClick={onBackClicked}>{resources.common.buttons.back.label}</Button>
                <ButtonWithSpinner
                    id="add-messaging-template-save-button"
                    disabled={requestInProgress || validationErrors.count > 0}
                    hideSpinner={validationErrors.count > 0}
                    variant="primary"
                    type={ButtonTypes.SUBMIT}
                    label={resource.buttons.addMessagingTemplate.label}
                />
            </Modal.Footer>
        </Form>
    );
};